class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.mainDetailsToggle.addEventListener('keydown', this.onKeyDown.bind(this));

    this.headerOverlay = document.querySelector('.header-wrapper--overlay');

    this.timeout = null;
    this.transitionListener = null;
    this.isOpen = false;
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '')
      return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  open() {
    if (this.isOpen) return;

    this.isOpen = true;
    this.clearTransitionEvents();

    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.mainDetailsToggle.setAttribute('open', true);

    requestAnimationFrame(() => {
      this.content.style.opacity = '1';
    });
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.clearTransitionEvents();

    super.close();
  }

  onMouseEnter() {
    clearTimeout(this.timeout);
    this.headerOverlay?.classList.add('header-wrapper--overlay-active');

    this.timeout = setTimeout(() => {
      this.open();
    }, 0);
  }

  onMouseLeave() {
    clearTimeout(this.timeout);
    this.clearTransitionEvents();

    this.content.style.opacity = '0';
    this.headerOverlay?.classList.remove('header-wrapper--overlay-active');

    this.transitionListener = () => {
      this.close();
      this.clearTransitionEvents();
    };

    this.content.addEventListener('transitionend', this.transitionListener, { once: true });

    this.fallbackTimeout = setTimeout(() => {
      this.close();
    }, 200);
  }

  clearTransitionEvents() {
    if (this.content && this.transitionListener) {
      this.content.removeEventListener('transitionend', this.transitionListener);
      this.transitionListener = null;
    }
    clearTimeout(this.fallbackTimeout);
  }

  onKeyDown(event) {
    const key = event.key;

    if (key === 'Enter' || key === ' ') {
      event.preventDefault();
      this.open();
      const firstLink = this.mainDetailsToggle.querySelector('.mega-menu a');
      if (firstLink) firstLink.focus();
    }

    if (key === 'Escape') {
      event.preventDefault();
      this.close();
      this.mainDetailsToggle.querySelector('summary').focus();
    }
  }
}

customElements.define('header-menu', HeaderMenu);
